import keycode from 'keycode';
import playbackRates from './playbackRates';
const STEP_SECONDS = 5;
const STEP_MORE_SECONDS = 10;
export default function (event) {
    const code = keycode(event);
    switch (code) {
        case 'f':
            event.preventDefault();
            toggleFullScreen(this);
            break;
        case 'm':
            event.preventDefault();
            toggleMute(this);
            break;
        case 'k':
        case 'space':
            event.preventDefault();
            togglePlay(this);
            break;
        case 'left':
            event.preventDefault();
            this.currentTime(this.currentTime() - STEP_SECONDS);
            break;
        case 'right':
            event.preventDefault();
            this.currentTime(this.currentTime() + STEP_SECONDS);
            break;
        case 'j':
            event.preventDefault();
            this.currentTime(this.currentTime() - STEP_MORE_SECONDS);
            break;
        case 'l':
            event.preventDefault();
            this.currentTime(this.currentTime() + STEP_MORE_SECONDS);
            break;
        case 'c':
            event.preventDefault();
            if (this.textTracks().length) {
                if (this.textTracks()[0].mode === 'showing') {
                    this.textTracks()[0].mode = 'hidden';
                }
                else {
                    this.textTracks()[0].mode = 'showing';
                }
            }
            break;
        case '0':
        case '1':
        case '2':
        case '3':
        case '4':
        case '5':
        case '6':
        case '7':
        case '8':
        case '9':
            {
                event.preventDefault();
                const position = parseInt('' + code);
                this.currentTime(parseInt(`${(this.duration() * position) / 10}`));
            }
            break;
        case '.':
            if (event.shiftKey) {
                event.preventDefault();
                const current = this.playbackRate();
                const index = playbackRates.findIndex(r => r === current);
                if (index >= 0 && index < playbackRates.length) {
                    this.playbackRate(playbackRates[index + 1]);
                }
            }
            break;
        case ',':
            if (event.shiftKey) {
                event.preventDefault();
                const current = this.playbackRate();
                const index = playbackRates.findIndex(r => r === current);
                if (index >= 1) {
                    this.playbackRate(playbackRates[index - 1]);
                }
            }
            break;
    }
}
function toggleFullScreen(player) {
    if (player.isFullscreen()) {
        player.exitFullscreen();
    }
    else {
        player.requestFullscreen();
    }
}
function toggleMute(player) {
    player.muted(!player.muted());
}
function togglePlay(player) {
    if (player.paused()) {
        player.play();
    }
    else {
        player.pause();
    }
}
